let StringUtils = {};

StringUtils.monthName = (month) => {

  let name;

  if (month[0] === '0')
    month = month[1];

  if (month === '1')
    name = 'Jan';
  else if (month === '2')
    name = 'Feb';
  else if (month === '3')
    name = 'Mar';
  else if (month === '4')
    name = 'Apr';
  else if (month === '5')
    name = 'May';
  else if (month === '6')
    name = 'Jun';
  else if (month === '7')
    name = 'Jul';
  else if (month === '8')
    name = 'Aug';
  else if (month === '9')
    name = 'Sep';
  else if (month === '10')
    name = 'Oct';
  else if (month === '11')
    name = 'Nov';
  else if (month === '12')
    name = 'Dec';

  return name;

};

StringUtils.convertMonthString = (month) => {
  let monthParts = month.split("/");
  return StringUtils.monthName(monthParts[1]) + '/' + monthParts[0];
};

StringUtils.titleize = (str) => {
  let words;

  if (str.indexOf('_') > - 1)
    words = str.split('_');
  else if (str.indexOf('-') > - 1)
    words = str.split('-');
  else
    words = str.split(' ');

  let array = []
  for (let i=0; i<words.length; ++i) {
    array.push(words[i].charAt(0).toUpperCase() + words[i].toLowerCase().slice(1))
  }
  return array.join(' ')
};

StringUtils.sanitize = (str, full = true) => {
  if (!(typeof str === 'string'))
    return str;

  let replacements = {
    'á': 'a', 
    'ã': 'a',
    'â': 'a',
    'é': 'e',
    'ê': 'e', 
    'í': 'i',
    'î': 'i',
    'ĩ': 'i',
    'ø': 'o',
    'ö': 'o',
    'ó': 'o',
    'ô': 'o',
    'ú': 'u',
    'û': 'u',
    'ü': 'u',
    '&': 'and',
    '\\$': 's', 
    '\\+': 'and',
    '"': '',
    "'": '',
    "’": '',
    '-': '',
    'ç': 'c',
    ':': ' ',
    '∆': 'a'
  };

  Object.keys(replacements).forEach(function(key){
    str = StringUtils.replaceAll(str.toLowerCase(), key, replacements[key]);
  });

  if (full) {
    str = str.replace(/\(.*\)/g, ''); 
    str = str.replace(/\[.*\]/g, ''); 
  }

  str = str.replace(/"([^"]+)"/g, '$1');
  str = str.replace(/'([^']+)'/g, '$1'); 
  str = str.replace(/\[.*\]/g, ''); 
  str = str.replace(/\s+/g, ' '); 
  str = StringUtils.titleize(str.toLowerCase().trim());

  return str;
};

StringUtils.equality = function(str1, str2)
{
  if (!(typeof str1 === 'string') || !(typeof str2 === 'string'))
    return false;
  return StringUtils.sanitize(str1) === StringUtils.sanitize(str2);
};

StringUtils.replaceAll = (str, pattern, newValue) => {
  return str.replace(new RegExp(pattern, 'g'), newValue);
};

StringUtils.inflect = (str, count) => { 

  if (count > 1)
    return `${str}s`;
  else
    return str;

}

module.exports = StringUtils;


// WEBPACK FOOTER //
// ./src/js/services/StringUtils.js